import { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Button, Form, Layout, Spin, message } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { updateCorporate, getCorporateById } from 'services/corporate.service'
import { useGlobalStore } from 'stores/global'
import { Popup } from 'components/common/portal/Popup'

import FormManageCorporate from 'components/features/corporate/components/FormManageCorporate'
const Content = Layout.Content

const EditCorporatePage = () => {
  const navigate = useNavigate()
  const param = useParams()
  const [form] = Form.useForm()
  const { setPageHeader } = useGlobalStore()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (param?.corporateId) {
      fetchCorporateById(param?.corporateId)
    }
  }, [param?.corporateId])

  const onFinish = (values) => {
    setLoading(true)
    Popup({
      title: 'แก้ไขข้อมูล',
      message: 'ต้องการบันทึกข้อมูลที่แก้ไขใช่หรือไม่?',
      okText: 'ตกลง',
      onOk: () => {
        const body = {
          ...values,
          corporateId: param?.corporateId,
        }
        delete body.taxId
        delete body.corporateNumber

        updateCorporate(body)
          .then((payload) => {
            if (payload.status.code === 200) {
              Popup({
                title: 'บันทึกข้อมูลสำเร็จ',
                message: 'ระบบบันทึกข้อมูลสำเร็จแล้ว',
                okText: 'ตกลง',
                onOk: () => navigate(`/corporate/${param?.corporateId}`),
                status: 'success',
              })
            }
            setLoading(false)
          })
          .catch(() => {
            Popup({
              title: 'บันทึกไม่สำเร็จ',
              message: <div className='text-xl font-bold'>กรุณาทำรายการใหม่อีกครั้ง</div>,
              okText: 'ตกลง',
              status: 'error',
            })
            message.error('Something went wrong')
            setLoading(false)
          })
      },
      cancelText: 'ยกเลิก',
      onCancel: () => {
        setLoading(false)
      },
      status: 'warning',
    })
  }

  const onFinishFailed = (error) => {
    console.log(error)
  }

  const fetchCorporateById = async (id) => {
    try {
      const payload = await getCorporateById(id)
      if (payload.status?.code === 200) {
        setPageHeader({
          title: `${payload.data?.corporateNumber} - ${payload.data?.corporateName?.th}`,
          subTitle: undefined,
          onBack: '/corporates',
          backIcon: null,
          extra: [
            <Button
              key={0}
              type='dashed'
              size='large'
              onClick={() => navigate(`/corporate/${param?.corporateId}`)}
            >
              Back
            </Button>,
          ],
        })

        form.setFieldsValue({
          ...payload.data,
          corporateId: payload.data?.corporate?._id,
          corporateGroup: payload.data?.corporateGroup?._id,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Content>
        <div className='w-2/3 m-auto m'>
          <div className='steps-content mt-10'>
            <Form
              form={form}
              name='order-form'
              layout='vertical'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
              requiredMark={false}
              scrollToFirstError={{
                behavior: 'smooth',
              }}
            >
              <Spin
                tip='Loading...'
                spinning={loading}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              >
                <div>
                  <FormManageCorporate form={form} corporateId={param?.corporateId} />
                </div>
              </Spin>
            </Form>
          </div>
        </div>
      </Content>
    </>
  )
}

export default EditCorporatePage
